import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentLoaderService } from './environment-loader.service';
import { Observable } from 'rxjs';
import { PagedResult } from '../models/paging';
import { PageEvent } from '@angular/material/paginator';
import { DiscountType } from '../enums/discount-type.enum';
import { Sort } from '@angular/material/sort';

@Injectable({
  providedIn: 'root',
})
export class AccessGroupSharedDiscountService {
  private http = inject(HttpClient);
  private environmentLoaderService = inject(EnvironmentLoaderService);

  apiUrl: string;
  constructor() {
    this.apiUrl = this.environmentLoaderService.config['serviceBaseUrl'] + '/api/v1/admin/access-group-shared-discount';
  }

  getSharedDiscounts(
    searchEvent: AccessGroupSharedDiscountSearchEvent
  ): Observable<PagedResult<IAccessGroupSharedDiscountSearchResultItem>> {
    const url = `${this.apiUrl}`;
    let params = new HttpParams();

    if (searchEvent?.query) {
      params = params.append('query', searchEvent.query);
    }
    if (searchEvent.paging?.pageIndex) {
      params = params.append('page', searchEvent.paging.pageIndex);
    }
    if (searchEvent.paging?.pageSize) {
      params = params.append('page-size', searchEvent.paging.pageSize);
    }
    if (searchEvent.sorting?.active) {
      params = params.append('sort-by', searchEvent.sorting?.active);
    }
    if (searchEvent.sorting?.direction) {
      params = params.append('sort-direction', searchEvent.sorting?.direction);
    }
    if (searchEvent.discountType) {
      params = params.append('discount-type', searchEvent.discountType);
    }
    return this.http.get<PagedResult<IAccessGroupSharedDiscountSearchResultItem>>(url, {
      params,
    });
  }

  create(discount: CreateAccessGroupSharedDiscountRequest): Observable<string> {
    const url = `${this.apiUrl}`;
    return this.http.post<string>(url, discount);
  }
  edit(identifier: string, discount: EditAccessGroupSharedDiscountRequest) {
    const url = `${this.apiUrl}`;
    return this.http.put<string>(`${url}/${identifier}`, discount);
  }
  delete(identifier: string) {
    const url = `${this.apiUrl}`;
    return this.http.delete(`${url}/${identifier}`);
  }
}

export class AccessGroupSharedDiscountSearchEvent {
  constructor(paging: PageEvent) {
    this.paging = paging;
    this.sorting = null;
  }
  query: string | null = null;
  discountType?: DiscountType | null;
  paging: PageEvent;
  sorting: Sort | null;
}

export interface IAccessGroupSharedDiscountSearchResultItem {
  identifier: string;
  id: number;
  name: string;
  amount: number;
  discount_type: DiscountType;
  created: Date;
  created_by: string;
  attached_access_group_count: number;
}

export interface CreateAccessGroupSharedDiscountRequest {
  name: string;
  discount_type: DiscountType;
  amount: number;
}
export interface EditAccessGroupSharedDiscountRequest {
  name: string;
  amount: number;
}
